export const categoriesFields = /* GraphQL */ `
  fragment categoriesFields on Categories {
    department {
      slug
    }
    category {
      slug
    }
    sub_category {
      slug
    }
  }
`
